import { http } from '@/http';

export const PIN_REQUIRED_LENGTH = 8;
export const PIN_REGEX = /^[a-zA-Z0-9]{8}$/;

export const setPin = async (pin: string) => {
	return http.post<Record<string, never>>('user/set-pin', { pin });
};
